<template lang="html">
  <button @click="$emit('click-action')"><span id="title">{{ title }}</span><br><span id="value">{{value}}</span></button>
</template>

<script>
export default {
  props: {
    title: String,
    value: Number
  }
}
</script>

<style lang="css" scoped>

button {
    margin: 0;
    padding: 20px;
    padding-bottom: 15px;
    font-size: 1.1em;
    letter-spacing: 0.2em;
    font-variant: small-caps;

    color: var(--primaryColor);
    background-color: var(--highlightColor);
    border: none;
    border-radius: 20px;
    width: 100%;
    box-shadow: 0 2px 2px rgba(0,0,0,0.2);
}
#title{
  letter-spacing: 0.1em;
}
#value{
  font-size: 1.4em;
  font-weight: bold;
}

</style>
